(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  // Triggers when the quantity of an item in the cart changes
  // Validates min quantity and applies automatic volume discounts
  function handleQtyObserver(mutationList) {
    let revalidateQuantity = false;

    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "value") {
        revalidateQuantity = true;
        break;
      }
    }

    if (revalidateQuantity) {
      validateQtys();
    }
  }

  // Get a list of active and inactive volume discount codes based on current cart quantities
  function getProdsWithVolumeDiscounts() {
    const elList = document.querySelectorAll(".ee-voldiscounts");

    let allCodes = [];
    let volumeDiscountData = {
      "inactiveCodes": [],
      "activeCodes": []
    };

    elList.forEach(function(el) {
      if (el.innerText == ':') {
        // No automatic volume discounts for this product
        return;
      }

      // Expected format example: "PREFIX:50,125,300"
      const prefixAndQuantities = el.innerText.split(":");

      if (prefixAndQuantities.length !== 2 || prefixAndQuantities[0] == '' || prefixAndQuantities[1] == '') {
        // Either the prefix or the quantity definition is missing from the discount definition
        return;
      }

      const quantities = prefixAndQuantities[1]
        .split(',')
        .map(qty => parseInt(qty)) // convert strings to ints
        .filter(qty => qty > 1) // remove invalid quantity values
        .sort((a, b) => a - b); // sort lowest to highest

      if (quantities.length == 0) {
        // No valid quantities were defined
        return;
      }

      const prefix = prefixAndQuantities[0];
      const elPar = el.parentElement.parentElement;
      const qtyEl = elPar.querySelector("[ref=quantityInput]");
      const cartQty = parseInt(qtyEl.value);
      let eligibleDiscount = null;
      
      // Determine which discount code applies
      quantities.forEach(function (volQty) {
        const discountCode = prefix + '_' + volQty;
        allCodes.push(discountCode);

        if (cartQty >= volQty) {
          eligibleDiscount = discountCode;
        }
      });

      if (eligibleDiscount) {
        volumeDiscountData.activeCodes.push(eligibleDiscount);
      }

      volumeDiscountData.inactiveCodes = allCodes.filter(code => !volumeDiscountData.activeCodes.includes(code));
    });

    return volumeDiscountData;
  }

  // Returns a list of already-applied discounts
  function getAppliedDiscounts() {
    const elList = document.querySelectorAll(".cart-discount__codes .cart-discount__pill-code");
    let finalList = [];

    elList.forEach(function(el) {
      const discountCode = el.innerText;
      finalList.push(discountCode);
    });

    return finalList;
  }

  // Apply automatic volume discounts
  function applyVolumeDiscounts() {
    const discountCodes = getProdsWithVolumeDiscounts();
    const appliedCodes = getAppliedDiscounts();
    const codesToAdd = discountCodes.activeCodes.filter(code => !appliedCodes.includes(code));
    const codesToRemove = appliedCodes.filter(code => !discountCodes.activeCodes.includes(code));

    if (codesToAdd.length > 0) {
      applyDiscountCodesToCart(codesToAdd);
    }
  }

  function applyDiscountCodesToCart(codes) {
    document.querySelectorAll("#cart-discount")[0].value = codes.join(',');
    document.querySelectorAll(".cart-discount__button")[0].click();
  }

  // Returns a list of products with minimum quantities
  function getProdsWithMinQty() {
    const elList = document.querySelectorAll(".ee-mq");
    let finalList = [];
    let groupCounter = 0;

    elList.forEach(function(el) {
      const min = parseInt(el.innerText);

      if (min > 0) {
        const elPar = el.parentElement.parentElement;
        const qtyEl = elPar.querySelector("[ref=quantityInput]");
        const qty = parseInt(qtyEl.value);
        let grp = el.parentElement.querySelector(".ee-mq-group").innerText;

        if (grp.length === 0) {
            // If group is empty, put the item into its own group with no other items
            grp = "_unique_mq_group_" + (groupCounter++);
        }

        finalList.push({
          min: min,
          qty: qty,
          grp: grp
        });
      }
    });

    return finalList;
  }

  function validateQtys() {
    validateMinQtys();
    applyVolumeDiscounts();
  }

  // Validates whether all products in the cart have met their min qty requirement
  function validateMinQtys() {
    let validationOkByGrp = {};
    let overallValidationOk = true;

    getProdsWithMinQty().forEach(function(el) {
      if (typeof validationOkByGrp[el.grp] === 'undefined') {
          validationOkByGrp[el.grp] = false;
      }

      if (el.qty >= el.min) {
        validationOkByGrp[el.grp] = true;
      }
    });

    for (let key in validationOkByGrp) {
        if (!validationOkByGrp[key]) {
            overallValidationOk = false;
            break;
        }
    }

    if (overallValidationOk) {
      document.querySelector("#checkout").innerText = "Check out";
      document.querySelector("#checkout").disabled = false;
    } else {
      document.querySelector("#checkout").innerText = "Invalid Quantity";
      document.querySelector("#checkout").disabled = true;
    }

    return overallValidationOk;
  }

  const elList = document.querySelectorAll("[ref=quantityInput]");
  const quantObserver = new MutationObserver(handleQtyObserver);

  elList.forEach(function (curEl) {
    quantObserver.observe(curEl, { attributes: true, childList: false, subtree: false, characterData: false });
  });

  document.querySelector("#cart-form").addEventListener('submit', function(event) {
    if (!validateMinQtys()) {
      event.preventDefault();
      setTimeout(validateMinQtys, 250);
    }
  });

  validateQtys();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
